import React, { useState } from 'react';
import { Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const MsalInput = ({ name, label, register, errors, isTypePassword = true }) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="msal_input">
            <div className='msal_input__field'>
                <Label className="col-12 col-md-3">{label}</Label>
                <div className="col-12 col-md-9" style={{ position: "relative" }}>
                    <input
                        className="form-control"
                        name={name}
                        ref={register({ required: true })}
                        type={isTypePassword ? (showPassword ? "text" : "password") : "text"}
                        maxLength={100}
                         autoComplete="off"
                    />
                    {isTypePassword && <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                        onClick={togglePasswordVisibility}
                        style={{
                            position: 'absolute',
                            right: '25px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer'
                        }}
                    />}
                    <small className="text-danger" style={{ position: "absolute", bottom: "-27px" }}>
                        {errors[name] && "This field is required"}
                    </small>
                </div>
            </div>
        </div>
    );
};

export default MsalInput;
